"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
var _zhjySerach = _interopRequireDefault(require("@/components/search/zhjySerach.vue"));
var _funBtn = _interopRequireDefault(require("@/components/funBtn/funBtn.vue"));
var _zhjyTable = _interopRequireDefault(require("@/components/table/zhjyTable.vue"));
var _zhjyPagination = _interopRequireDefault(require("@/components/zhjyPagination/zhjyPagination.vue"));
var _project = require("@/api/project/project");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      addDialog: false,
      queryGroup: [{
        label: "精确查找",
        type: "input",
        model: "queryValue",
        placeholder: "姓名/账号"
      }],
      modelData: {
        queryValue: ""
      },
      modelData2: {
        queryValue: ""
      },
      defaultColumn: [{
        name: "姓名",
        prop: "name",
        isShow: true,
        width: "200"
      }, {
        name: "登录账号",
        prop: "loginName",
        isShow: true,
        width: "200"
      }, {
        name: "所属学校",
        prop: "schoolName",
        isShow: true,
        width: "200"
      }],
      defaultColumn2: [{
        name: "姓名",
        prop: "name",
        isShow: true,
        width: "60"
      }, {
        name: "所属学校",
        prop: "schoolName",
        isShow: true,
        width: "80"
      }, {
        name: "登录账号",
        prop: "loginName",
        isShow: true,
        width: "100"
      }],
      funBtns: [{
        size: "small",
        click: "removeTec",
        icon: "el-icon-delete",
        name: "批量删除",
        type: "danger"
      }, {
        size: "small",
        click: "addNews",
        icon: "el-icon-circle-plus-outline",
        name: "添加新成员",
        type: "primary"
      }],
      minWidth: 300,
      page: {
        pageNumber: 1,
        pageSize: 10
      },
      page2: {
        pageNumber: 1,
        pageSize: 10
      },
      totalData: 0,
      totalData2: 0,
      listData: [],
      listData2: [],
      options: [{
        name: "删除",
        class: "delet",
        option: "removeTec",
        span: 24
      }],
      formatters: {
        belongAdministrator: []
      },
      sort: {
        prop: "",
        order: ""
      },
      checkBoxs: [],
      checkBoxs2: [],
      queryValue: "",
      queryValue2: ""
    };
  },
  methods: {
    // 移出阶段下的专家
    removeTec: function removeTec(row) {
      var _this = this;
      var id = [];
      if (!row && this.checkBoxs.length === 0) {
        return this.$message.error("请先勾选数据");
      } else if (row) {
        id.push(row.id);
      } else if (this.checkBoxs.length > 0) {
        id = this.checkBoxs;
      }
      this.$confirm("确认删除吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      }).then(function () {
        (0, _project.stageTecDel)({
          idList: id
        }).then(function () {
          _this.getStageTecList();
          _this.$message.success("操作成功。");
        });
      }).catch(function () {
        _this.$message.info("取消删除。");
      });
    },
    // 提交分配结果
    submit: function submit() {
      var _this2 = this;
      if (this.checkBoxs2.length > 0) {
        (0, _project.stageTecAdd)({
          stageId: this.$route.query.stageId,
          expertIds: this.checkBoxs2
        }).then(function (res) {
          console.log(res);
          if (res.code === 2000) {
            _this2.addDialog = false;
            _this2.$message.success("操作成功。");
            _this2.getStageTecList();
          }
        });
      } else {
        this.$message.error("请先勾选数据。");
      }
    },
    // 获取待分配专家
    getNoStageTec: function getNoStageTec() {
      var _this3 = this;
      (0, _project.noStageTec)({
        name: this.queryValue2,
        pageNum: this.page2.pageNumber,
        pageSize: this.page2.pageSize,
        stageId: this.$route.query.stageId
      }).then(function (res) {
        console.log(res);
        var data = res.data;
        _this3.listData2 = data.list;
        _this3.totalData2 = data.total;
      });
    },
    // 添加新成员
    addNews: function addNews() {
      this.getNoStageTec();
      this.addDialog = true;
    },
    // dialog查找
    search2: function search2(e) {
      this.queryValue2 = e.queryValue;
      this.getNoStageTec();
    },
    // 获取阶段下的专家
    getStageTecList: function getStageTecList() {
      var _this4 = this;
      (0, _project.tecLsit)({
        name: this.queryValue,
        pageNum: this.page.pageNumber,
        pageSize: this.page.pageSize,
        stageId: this.$route.query.stageId
      }).then(function (res) {
        var data = res.data;
        _this4.listData = data.list;
        _this4.totalData = data.total;
      });
    },
    listBureau: function listBureau() {},
    dels: function dels() {},
    // 新增
    save: function save() {
      this.$router.push("/object/technocracy-add");
    },
    edit: function edit() {
      this.$router.push("/object/technocracy-edit");
    },
    handleSelectionChange: function handleSelectionChange(e) {
      var _this5 = this;
      this.checkBoxs = [];
      e.forEach(function (item) {
        _this5.checkBoxs.push(item.id);
      });
    },
    handleSelectionChange2: function handleSelectionChange2(e) {
      var _this6 = this;
      this.checkBoxs2 = [];
      e.forEach(function (item) {
        _this6.checkBoxs2.push(item.id);
      });
    },
    deleteById: function deleteById() {},
    distribution: function distribution() {},
    viewAdmin: function viewAdmin() {},
    sortChange: function sortChange() {},
    handleCurrentChange: function handleCurrentChange(e) {
      this.page.pageNumber = e;
      this.getStageTecList();
    },
    handleSizeChange: function handleSizeChange(e) {
      this.page.pageSize = e;
      this.page.pageNumber = 1;
      this.getStageTecList();
    },
    handleCurrentChange2: function handleCurrentChange2(e) {
      this.page2.pageNumber = e;
      this.getNoStageTec();
    },
    handleSizeChange2: function handleSizeChange2(e) {
      this.page2.pageSize = e;
      this.page2.pageNumber = 1;
      this.getNoStageTec();
    },
    handleClose: function handleClose(done) {
      done();
    }
  },
  created: function created() {
    this.getStageTecList();
  },
  components: {
    ZhjySerach: _zhjySerach.default,
    ZhjyPagination: _zhjyPagination.default,
    FunBtn: _funBtn.default,
    ZhjyTable: _zhjyTable.default
  }
};